// extracted by mini-css-extract-plugin
export default {"checkbox":"Option_checkbox__wmEY1","multiple":"Option_multiple__9I0a1","checked":"Option_checked__mZHlz","icon":"Option_icon__JwFJ2"};